// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyCtaFooter-cls1_hxX","cls2":"StickyCtaFooter-cls2_Tpo StickyCtaFooter-cls1_hxX"};